import React, { useCallback, useEffect, useState } from "react";
import ChatHeader from "./GroupChatHeader/ChatHeader";
import ChatSearch from "./GroupChatSearch/GroupChatSearch";
import SingleChatSideBarHeader from "../../../Components/MainChatSideBarHeader/SingleChatSideBarHeader";
import ChatListItem from "./GroupChatList/GroupChatsSectionListItems/GroupChatSections/ChatListItem/ChatListItem";
import AddGroupHeader from "./GroupChatHeader/AddGroupHeader/AddGroupHeader";
import SelectedChatAvatars from "./GroupChatList/GroupChatsSectionListItems/GroupChatSections/SelectedChatAvatars/SelectedChatAvatars";
import ChatListFooter from "./GroupChatList/GroupChatsSectionListItems/GroupChatSections/ChatListFooter/ChatListFooter";
import NewGroupHeader from "./GroupChatHeader/NewGroupHeader/NewGroupHeader";
import NewGroupSection from "./GroupChatList/GroupChatsSectionListItems/GroupChatSections/NewGroupSection/NewGroupSection";
import AddChannel from "./GroupChatHeader/AddChannel/AddChannel";
import CreateChannel from "./GroupChatList/GroupChatsSectionListItems/NewChannelSections/CreateChannel/CreateChannel";
import ChannelUpload from "./GroupChatList/GroupChatsSectionListItems/NewChannelSections/ChannelUpload/ChannelUpload";
import AddSubscriber from "./GroupChatHeader/AddSubscriber/AddSubscriber";
import ChannelType from "./GroupChatList/GroupChatsSectionListItems/NewChannelSections/ChannelType/ChannelType";
import GroupChatSearch from "./GroupChatSearch/GroupChatSearch";
import GroupUserList from "../../ChatMenu/ChatSideBar/ChatList/ChatsSectionListItems/GroupChatSections/ChatListItem/GroupUserList";
import AllUserList from "../../../Components/AllUserList/AllUserList";
import ChatListHeader from "../../ChannelMenu/ChannelSidebar/GroupChatList/GroupChatsSectionListItems/GroupChatSections/ChatListHeader/ChatListHeader";
import { getApiCaller } from "../../../Libs/apiCaller";
import { toast } from "react-toastify";
import { FadeLoader } from "react-spinners";
import { useSelector } from "react-redux";
import {
  decryptMessage,
  decryptText,
} from "../../../Components/EncryptDecryptMessage/EncryptDecryptMessage";
import InfiniteScroll from "../../../Components/InfiniteScroll/InfiniteScroll";

export default function GroupChatSideBar({
  AllUser,
  setGroupActiveChat,
  setChatConversationId,
  setGetSecretKey,
  fetchAllUser,
  setChatSearch,
  allGroups,
  setAllGroups,
  groupActiveChat,
  userSearch,
  fetchGroups,
  currentPage,
  totalPages,
  search,
  isLoading,
  setSearch,
  setIsLoading,
  setActiveSection,
  setIsMessageLoading,
  allUserCurrentPage,
  allUserTotalPages,
  setShowProfileView,
}) {
  const { userInfo } = useSelector((state) => state.authUser);
  const [moreNewChat, setMoreNewChat] = useState(false);
  const [selectedChats, setSelectedChats] = useState([]);
  const [createNewGroupSection, setCreateNewGroupSection] = useState(0);
  const [allGroupsMessage, setAllGroupsMessage] = useState([]);

  useEffect(() => {
    if (createNewGroupSection === 0) {
      setIsLoading(true);
      fetchGroups(false, 1, "");
    }
  }, [createNewGroupSection]);

  const handleSelectChat = (user) => {
    setShowProfileView(false);
    const alreadySelected = selectedChats.find((u) => u._id === user._id);
    if (alreadySelected) {
      setSelectedChats((prev) => prev.filter((u) => u._id !== user._id));
    } else {
      setSelectedChats((prev) => [...prev, user]);
    }
  };

  const handleRemoveSelected = (id) => {
    setSelectedChats((prev) => prev.filter((chat) => chat._id !== id));
  };

  const getAllMessages = useCallback(async () => {
    if (!userInfo?.encryptedPrivateKey) return; // Guard clause to avoid running if userInfo is not available

    return await Promise.all(
      allGroups.map(async (msg) => {
        const getSecretKey = await decryptText(
          msg?.conversationId?.AESKeyOfUser,
          userInfo?.encryptedPrivateKey
        );
        if (msg?.latestMessage?.cipherText) {
          try {
            const decryptedText = await decryptMessage(
              msg?.latestMessage?.cipherText,
              msg.latestMessage.iv,
              getSecretKey
            );

            return {
              ...msg,
              latestMessage: {
                ...msg.latestMessage,
                cipherText: decryptedText,
              },
            };
          } catch (err) {
            console.error("Decryption failed:", err);
            return {
              ...msg,
              latestMessage: {
                ...msg.latestMessage,
                cipherText: "",
              },
            };
          }
        }
        return msg;
      })
    );
  }, [allGroups, userInfo]);

  useEffect(() => {
    if (!userInfo?.encryptedPrivateKey) return;

    (async () => {
      const messages = await getAllMessages();
      if (messages) {
        // Sort messages by sentTime
        const sortedMessages = messages.sort((a, b) => {
          const timeA = a.latestMessage?.sentTime || a.sortTime;
          const timeB = b.latestMessage?.sentTime || b.sortTime;
          return new Date(timeB) - new Date(timeA);
        });
        setAllGroupsMessage(sortedMessages);
      }
    })();
  }, [getAllMessages, allGroups]);

  return (
    <section className="w-full h-full bg-zinc-50 dark:bg-slate-900">
      {createNewGroupSection === 1 ? (
        <AddGroupHeader
          setCreateNewGroupSection={setCreateNewGroupSection}
          fetchAllUser={fetchAllUser}
        />
      ) : createNewGroupSection === 2 ? (
        <NewGroupHeader setCreateNewGroupSection={setCreateNewGroupSection} />
      ) : (
        <SingleChatSideBarHeader
          moreNewChat={moreNewChat}
          setMoreNewChat={async () => {
            if (userSearch) await fetchAllUser(1, "");
            setSelectedChats([]);
            setCreateNewGroupSection(1);
            setChatSearch("");
          }}
          setSearch={setSearch}
        />
      )}
      <div className="bg-zinc-50 dark:bg-slate-900 h-full">
        {createNewGroupSection === 0 && (
          <div className="m-4">
            <GroupChatSearch
              search={search}
              fetchGroups={fetchGroups}
              fetchAllUser={fetchAllUser}
              createNewGroupSection={createNewGroupSection}
            />
          </div>
        )}
        {createNewGroupSection == 1 && (
          <div className="m-4">
            <GroupChatSearch
              search={userSearch}
              fetchGroups={fetchGroups}
              fetchAllUser={fetchAllUser}
              createNewGroupSection={createNewGroupSection}
            />
          </div>
        )}
        {isLoading && (
          <div className="h-[70vh] content-center justify-items-center">
            <FadeLoader color="#7104F8" loading={true} size={12} />
          </div>
        )}{" "}
        <div
          className="flex flex-col p-4 pt-0 pr-3 overflow-y-auto scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-200 bg-zinc-50 dark:bg-slate-900"
          style={{
            height:
              createNewGroupSection === 4 ||
                (createNewGroupSection === 1 && selectedChats.length > 0)
                ? "calc(100vh - 230px)"
                : "calc(100vh - 150px)",
            minHeight:
              createNewGroupSection === 4 ||
                (createNewGroupSection === 1 && selectedChats.length > 0)
                ? "calc(100vh - 230px)"
                : "calc(100vh - 150px)",
            maxHeight:
              createNewGroupSection === 4 ||
                (createNewGroupSection === 1 && selectedChats.length > 0)
                ? "calc(100vh - 230px)"
                : "calc(100vh - 150px)",
          }}
        >
          {createNewGroupSection === 1 && (
            <SelectedChatAvatars
              selectedChats={selectedChats}
              handleRemoveSelected={handleRemoveSelected}
            />
          )}
          {moreNewChat && createNewGroupSection !== 2 && (
            <ChatListHeader
              setCreateNewGroupSection={setCreateNewGroupSection}
              type="group"
              setMoreNewChat={setMoreNewChat}
            />
          )}

          {createNewGroupSection === 1 && (
            <>
              {AllUser?.length > 0 && (
                <InfiniteScroll
                  dataLength={AllUser.length}
                  next={() => fetchAllUser(allUserCurrentPage + 1, "")}
                  hasMore={allUserCurrentPage < allUserTotalPages}
                  loader={<p className="text-center">Loading...</p>}
                >
                  {AllUser.map((item) => (
                    <AllUserList
                      key={item._id}
                      users={item}
                      selected={selectedChats.some((u) => u._id === item._id)}
                      handleSelectChat={handleSelectChat}
                    />
                  ))}
                </InfiniteScroll>
              )}
              {AllUser.length <= 0 && (
                <div className="flex-grow flex items-center justify-center h-full">
                  <p className="text-[#7104F8] font-semibold">
                    Member Not Found
                  </p>
                </div>
              )}
            </>
          )}
          {createNewGroupSection === 0 && !isLoading ? (
            allGroups.length > 0 ? (
              <InfiniteScroll
                dataLength={allGroupsMessage.length} //This is important field to render the next data
                next={() => fetchGroups(true, currentPage + 1)}
                hasMore={totalPages > currentPage}
                loader={<p className="text-center">Loading...</p>}
              >
                {allGroupsMessage.map((item) => (
                  <GroupUserList
                    key={item._id}
                    chat={item}
                    moreNewChat={moreNewChat}
                    groupActiveChat={groupActiveChat}
                    setGroupActiveChat={setGroupActiveChat}
                    setChatConversationId={setChatConversationId}
                    setGetSecretKey={setGetSecretKey}
                    setActiveSection={setActiveSection}
                    setIsMessageLoading={setIsMessageLoading}
                    setShowProfileView={setShowProfileView}
                  />
                ))}
              </InfiniteScroll>
            ) : (
              <div className="min-h-[calc(100dvh-170px)] content-center justify-items-center">
                <p className="text-[#7104F8] font-semibold text-xl mb-16">
                  Group Not Found
                </p>
              </div>
            )
          ) : (
            ""
          )}
          {createNewGroupSection === 2 && (
            <NewGroupSection
              setGroupActiveChat={setGroupActiveChat}
              handleCreateGroupDone={() => {
                setSearch("");
                fetchGroups(false, 1, "");
              }}
              selectedChats={selectedChats}
              setSelectedChats={setSelectedChats}
              setCreateNewGroupSection={setCreateNewGroupSection}
              setChatConversationId={setChatConversationId}
              setGetSecretKey={setGetSecretKey}
            />
          )}
        </div>
        <div className="m-4">
          {createNewGroupSection === 1 && selectedChats.length >= 1 && (
            <ChatListFooter
              onDone={() => {
                setCreateNewGroupSection(2);
              }}
            />
          )}
        </div>
      </div>
    </section>
  );
}
